import React from "react";

import clickTrackerService, {
  ClickTrackerService,
} from "@app/util/clickTracker/ClickTrackerService";

const ClickTrackerContext = React.createContext<ClickTrackerService>(clickTrackerService);

export default ClickTrackerContext;
